import { get } from '../api-service';

export const checkLegacySubscriptionId = () => {
  return get('/auth/data_legacy');
};
